enum PropriedadeFinxEnum {
  NaoEncontrato = 'NaoEncontrato',
  StatusSituacao = 'StatusSituacao',
  TipoProcedimento = 'TipoProcedimento',
  Carater = 'Carater',
  ReservaHemocomponentes = 'ReservaHemocomponentes',
  ExamesIntraOperatorios = 'ExamesIntraOperatorios',
  HonorarioMedico = 'HonorarioMedico',
  ReservaUTI = 'ReservaUTI',
  AnestesiaDoHospital = 'AnestesiaDoHospital',
  AutorizacaoStatus = 'AutorizacaoStatus',
  TemCongelacao = 'TemCongelacao',
  TesteCovid = 'TesteCovid',
  TemMarcapasso = 'TemMarcapasso',
  Reoperacao = 'Reoperacao',
  TipoDeAutorizacao = 'TipoDeAutorizacao',
  NecessitaTipagemSanguinea = 'NecessitaTipagemSanguinea',
  ReservaHemocomponenteSimples = 'ReservaHemocomponenteSimples',
  TipoAcomodacao = 'TipoAcomodacao',
  LocalAtendimentoId = 'LocalAtendimentoId',
  Opme = 'Opme',
  TempoCirurgia = 'TempoCirurgia',
  Precaucoes = 'Precaucoes',
  AlergiaLatex = 'AlergiaLatex',
  MedicamentosEspeciais = 'MedicamentosEspeciais',
  MedicacaoContinua = 'MedicacaoContinua',
  EquipeMedica = 'EquipeMedica',
  TecnicaDaCirurgia = 'TecnicaDaCirurgia',
  ObservacaoReservaSala = 'ObservacaoReservaSala',
  StatusAutorizacaoDoOpmeNoAgendamento = 'StatusAutorizacaoDoOpmeNoAgendamento',
  ConvenioParticular = 'ConvenioParticular',
  Lateralidade = 'Lateralidade',
  PrevisaoDeUsoQuimioterapico = 'PrevisaoDeUsoQuimioterapico',
  OrientacoesDePreparoDoPaciente = 'OrientacoesDePreparoDoPaciente',
  InstrucoesParaOAgendamento = 'InstrucoesParaOAgendamento',
  TemOpme = 'TemOpme',
  EquipamentosSemHisId = 'EquipamentosSemHisId',
  StatusDoDomain = 'StatusDoDomain',
  PesoDoPaciente = 'PesoDoPaciente',
  IndicacaoClinica = 'IndicacaoClinica',
  InternacaoDeVespera = 'InternacaoDeVespera',
  TipoInternacao = 'TipoInternacao',
  RegiaoDaCirurgia = 'RegiaoDaCirurgia',
  HonorarioAnestesista = 'HonorarioAnestesista',
  DescricaoOpmes = 'DescricaoOpmes',
  Equipamentos = 'Equipamentos',
  TipoAnestesia = 'TipoAnestesia',
  RegistraProtocoloDeRecuperacaoPrecoce = 'RegistraProtocoloDeRecuperacaoPrecoce',
  Cbo = 'Cbo',
  Cid = 'Cid',
  Alergias = 'Alergias',
  TipoAgendamento = 'TipoAgendamento',
  SnImpresso = 'SnImpresso',
  CodigoMultiEmpresa = 'CodigoMultiEmpresa',
}

export default PropriedadeFinxEnum
